'use client';

import { BetterButton } from '@dealerportal/ui-components/BetterButton';
import classNames from 'classnames';
import { type ReactNode, useEffect, useState } from 'react';

type Props = {
  tip?: string;
  show: boolean;
  children?: ReactNode | ReactNode[];
  position?: 'top-left' | 'top-right' | 'top-center';
  showX?: boolean;
};

export const Tooltip = ({
  tip,
  children,
  show,
  position = 'top-center',
  showX = false,
}: Props) => {
  const [showTooltip, setShowTooltip] = useState(show);

  useEffect(() => {
    setShowTooltip(show);
  }, [show, setShowTooltip]);

  return (
    <div
      role="tooltip"
      className={classNames(
        'tooltip ui-absolute ui-max-w-48 ui-w-max ui-py-0.5 ui-px-1.5 ui-text-xs ui-text-white ui-font-semibold ui-bg-gray-800 ui-rounded-md',
        {
          'ui-opacity-100 ui-visible': showTooltip,
          'ui-opacity-0 ui-hidden': !showTooltip,
          'ui-bottom-[calc(100%+4px)] ui-left-0 md:ui-left-1/2 md:-ui-translate-x-1/2':
            position === 'top-center',
          'ui-bottom-[calc(100%+4px)] ui-left-0': position === 'top-left',
          'ui-bottom-[calc(100%+4px)] ui-right-0': position === 'top-right',
        }
      )}
    >
      <div className="ui-flex ui-gap-1.5">
        <div className="tooltip__tip">{tip || children}</div>
        {showX && (
          <BetterButton
            icon={`<svg class="ui-fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"/></svg>`}
            iconSize="2"
            btnStyle="simple"
            className="tooltip__close"
            attributes={{
              type: 'button',
              onClick: () => setShowTooltip(false),
            }}
          />
        )}
      </div>

      <div
        className={classNames({
          'ui-w-3 ui-h-3 ui-absolute ui-bottom-[-6px] ui-left-1 md:ui-left-1/2 md:-ui-translate-x-1/2':
            position === 'top-center',
          'ui-w-3 ui-h-3 ui-absolute ui-bottom-[-6px] ui-left-1':
            position === 'top-left',
          'ui-w-3 ui-h-3 ui-absolute ui-bottom-[-6px] ui-right-1':
            position === 'top-right',
        })}
      >
        <svg
          className="ui-fill-gray-800 ui-w-full"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 320 512"
        >
          <path d="M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z" />
        </svg>
      </div>
    </div>
  );
};
